import { InputWrapper, InputContainer } from "./TextInput.styled"

const InputText = ({ type = 'text', placeholder, value, onChange, onBlur,  onKeyDown, width, height, margin, backgroundColor, disabled, validationError, displayError=false, displaySuccess=false }) => {
    return (
        <InputContainer margin={margin}>
            <InputWrapper
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                width={width}
                backgroundColor={backgroundColor}
                disabled={disabled}
                $error={displayError}
                $success={displaySuccess}
                height={height}
            />
            {displayError &&  <span>{validationError}</span>}
        </InputContainer>
    );
}

export default InputText;
